import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { setMailOpen,setMailClose,sendDraftEmail,updateEmailStatusThunk,fetchEmailBody } from "../../store/features/emailsSlice";
import {
  updateRequiredActions,
  updateShipmentStatus,
  updateShipmentIssue
} from "../../store/features/shipmentsSlice";
import { MailIcon,EnvelopeIcon } from "@heroicons/react/24/outline";
import API_BASE_URL from "../../apis/api";
import SuccessMessageBox from "../Notification/Success";
import axios from "axios";

const EmailBody = ({ threadId, caseNumber, email }) => {

  const [showSuccessMessage, setShowSuccessMessage] = useState(false); // State for success message visibility
  const dispatch = useDispatch();
  const currentEmail = useSelector((state) => state.emails.currentMail);
  const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  const {emailBodies} = shipment;
  const emailId = currentEmail.id
  const [emailBody, setEmailBody] = useState("");
  const [error, setError] = useState(null);
  const [body, setBody] = useState("");
  const [isDraft, setIsDraft] = useState(false);
  const [toEmail, setToEmail] = useState("");
  const [fromEmail, setFromEmail] = useState("");
  const [ccEmail, setCcEmail] = useState("");
  const [showCC, setShowCC] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchEmailDetails = async () => {
      try {
        // Reset all states when switching emails or fetching new email details
        setBody("");
        setIsDraft(false);
        setToEmail("");
        setFromEmail("");
        setCcEmail("");
        setShowCC(false);
        setLoading(true);
        setError(null);
  
        // Set the email body
        const emailBody = emailBodies.find((email) => email.id === emailId);
        const body = emailBody?.body || "Empty Email"
        setBody(body);
  
        const isCurrentDraft = currentEmail.status === "draft";
        setIsDraft(isCurrentDraft);
  
        // Set additional details for drafts
        if (isCurrentDraft) {
          setToEmail(currentEmail.to?.email || "Not Available for now");
          setFromEmail(currentEmail.sender || "");
        }
      } catch (err) {
        console.error("Error fetching email details:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    fetchEmailDetails();
  }, [threadId, emailId]);

  const handleClose = () => {
    dispatch(setMailClose());
    setBody("");
    setIsDraft(false);
    setToEmail("");
    setFromEmail("");
    setCcEmail("");
    setShowCC(false);
  };


  const handleSend = async() => {
    dispatch(
      sendDraftEmail({
        caseNumber: caseNumber,
        email: "supplychain@linear-works.com",
        thread_id: threadId,
        reply_text: body,
      })
    )
      .unwrap()
      .then((response) => {
        console.log("Draft email sent successfully:", response);
      })
      .catch((error) => {
        console.error("Failed to send draft email:", error);
      });
  };

  const handleSendClick = async () => {
    try {
      setShowSuccessMessage(true); // Show success popup
  
      // Automatically hide the message and close the modal after 2 seconds
      setTimeout(async () => {
        setShowSuccessMessage(false); // Hide the success message
        handleClose(); // Close the modal
  
        // Call save function after the modal is closed
        await handleSend();
  
        // Redirect to the dashboard
        // window.location.href = "/dashboard";
      }, 2000);
    } catch (error) {
      console.error("Failed to send emails:", error);
      alert("Failed to send email. Please try again.");
    }
  };

  if (!currentEmail) {
    return (
      <div className="flex flex-col items-center justify-center h-full text-center text-gray-500">
        <EnvelopeIcon className="w-24 h-24 text-gray-400 mb-4" />
        <p className="text-lg">Select an email from the list to view its content.</p>
      </div>
    );
  }

  return (
    <div className="p-6 border rounded-md h-full flex flex-col bg-white shadow">
      {isDraft ? (
        <>
        <div className="p-3 h-full flex flex-col overflow-auto">
        {/* Header Buttons */}
        <div className="flex justify-between items-center mb-6">
          <button
            onClick={handleSendClick}
            className="flex items-center gap-2 px-4 py-2 text-white bg-logo rounded hover:bg-logo-darker transition-all"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
              />
            </svg>
            Send
          </button>
        </div>

        {/* Recipients and Subject */}
        <div className="flex flex-col gap-4 mb-6 border-border-document">
          <div className="flex items-center w-full border-b border-border-document">
            <label className="font-bold mr-4 min-w-[50px]">From:</label>
            <input
              type="email"
              value={fromEmail}
              onChange={(e) => setFromEmail(e.target.value)}
              className="p-2 w-full focus:outline-none focus:ring-2 focus:ring-logo"
              placeholder="Add sender"
            />
          </div>
          {/* <div className="flex items-center w-full  border-b border-border-document">
            <label className="font-bold mr-4 min-w-[50px]">To:</label>
            <input
              type="email"
              value={toEmail}
              onChange={(e) => setToEmail(e.target.value)}
              className="p-2 w-full focus:outline-none focus:ring-2 focus:ring-logo"
              placeholder="Add recipient"
            />
            <button
              onClick={() => setShowCC(!showCC)}
              className="text-font hover:underline ml-4"
            >
              CC
            </button>
          </div>
          {showCC && (
            <div className="flex items-center w-full border-b border-border-document">
              <label className="font-bold mr-4 min-w-[50px]">CC:</label>
              <input
                type="email"
                value={ccEmail}
                onChange={(e) => setCcEmail(e.target.value)}
                className="p-2 w-full focus:outline-none focus:ring-2 focus:ring-logo"
                placeholder="Add CC"
              />
            </div>
          )} */}
          <div className="flex items-center w-full  border-b border-border-document">
            <label className="font-bold mr-3 min-w-[50px]">Subject:</label>
            <input
              type="text"
              value={currentEmail.subject}
              className="p-1 w-full focus:outline-none focus:ring-2 focus:ring-logo"
              placeholder="Add a subject"
            />
          </div>
        </div>

        {/* Editable Email Body */}
          <textarea
            className="flex-1 h-full p-3 rounded focus:outline-none focus:ring-2 focus:ring-logo resize-none overflow-auto text-gray-800"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            placeholder="Write your email here..."
            style={{ minHeight: "400px", maxHeight: "100%" }}
          />
      </div>
        </>
      ) : (
        <>
        <div className="flex flex-col h-full">
          {/* Header with Subject and Close Button */}
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl font-bold">{currentEmail.subject}</h2>
            <button
              onClick={handleClose}
              className="px-4 py-2 text-logo border border-logo bg-white rounded hover:bg-logo hover:text-white"
            >
              Close
            </button>
          </div>

          {/* Email Meta Information */}
          <div className="mb-4">
            <p>
            <strong>From:</strong> {currentEmail.sender || "Unknown Sender"}
            </p>
            <p>
              <strong>Date:</strong> {new Date(currentEmail.date_received).toLocaleString()}
            </p>
          </div>

          {/* Email Body */}
          <div
            className="flex-1 p-4 text-gray-800 bg-white rounded-md overflow-auto"
            style={{
              minHeight: "400px",
              maxHeight: "100%", // Adjust height relative to the parent container
              overflowY: "auto", // Enable vertical scrolling if content exceeds container height
              wordWrap: "break-word", // Prevent long words from breaking the layout
              whiteSpace: "pre-wrap", // Maintain original spacing and line breaks
            }}
          >
            {body}
          </div>
        </div>
        </>
      )}
       {/* Success Message Popup */}
       {showSuccessMessage && (
                <SuccessMessageBox
                  message="Email successfully sent"
                />
            )}
    </div>
    
  );
};

export default EmailBody;